import RequirementItem from "./RequirementItem";
export default RequirementItem;